// src/api/alumnos.ts
import axios from "./axios";
import { AsigAlumnoRow } from "./reports";

export async function getAlumnosAsignatura(
  profesorId: number,
  asignaturaId: number,
  desde: string
) {
  const { data } = await axios.get<AsigAlumnoRow[]>(
    `/reports/asignatura/${profesorId}/${asignaturaId}/alumnos`,
    { params: { desde } }
  );
  return data;
}
